
export const useAuthDrawer = () =>
  useState<boolean>('authDrawerOpen', () => false)

export const useAuthToken = () =>
  useState<string | null>('authToken', () => null)

export const useAuthEmail = () =>
  useState<string | null>('authEmail', () => null)
